import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Article } from '../../../model/Article';
import { PaginatedCollection } from '../../../model/Pagination';
import HttpClient, { Callback, CallbackType } from '../api';

export interface PaginatedArticles extends PaginatedCollection<Article> {
  category: string;
}

export interface PaginatedArticlesState {
  items: Array<Article> | null;
}

const INITIAL_STATE: PaginatedArticlesState = {
  items: null,
};

const paginatedArticlesSlice = createSlice({
  name: 'paginated-articles',
  initialState: INITIAL_STATE,
  reducers: {
    addPaginatedArticles: (state, action: PayloadAction<Article>) => {
      const items = state.items?.map((it) => {
        if (it.category.name === action.payload.category.name) {
          return action.payload;
        }
        return it;
      });
      console.log(items);
      return {
        ...state,
        items: items ? [...items!] : [action.payload],
      };
    },
    updatePaginatedArticles: (state, action: PayloadAction<Article>) => {
      const items = state.items?.map((it) => {
        if (it.id === action.payload.id) {
          return { ...it, ...action.payload };
        }
        return it;
      });
      return {
        ...state,
        items: items ?? [],
      };
    },
  },
});

export const { addPaginatedArticles, updatePaginatedArticles } = paginatedArticlesSlice.actions;

export default paginatedArticlesSlice.reducer;

export const findArticles = (apiQuery: Map<string, string>) => {
  const customErrorsMap = new Map<number, string>();
  customErrorsMap.set(
    404,
    'A configuração do site precisa ser executada antes de abrir essa página',
  );
  return HttpClient.findArticlesByQuery(apiQuery, addPaginatedArticles.type, customErrorsMap);
};

export const findArticleByCategory = (
  category: string,
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      full: false,
      function: () => console.log('findArticleByCategory by category success'),
    },
  ],
) => {
  const customErrorsMap = new Map<number, string>();
  customErrorsMap.set(
    404,
    'A configuração do site precisa ser executada antes de abrir essa página',
  );
  const apiQuery = new Map<string, string>();
  apiQuery.set('category', category);
  return HttpClient.findArticlesByQuery(
    apiQuery,
    addPaginatedArticles.type,
    customErrorsMap,
    [],
    callbacks,
  );
};
